var Verify = function() {
    return {
        validated: false,
        init: function(email) {
            Verify.email = email;
            $('#verify_email').keyup(function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    $('#verify-submit').click();
                }
            });
            $('#verify-submit').click(function() {
                Verify.submit(Verify.email);
            });
        },
        submit: function(email) {
            if (!Generic.hasMinChars(document.frm.email, 7)) {
                return;
            }

            if (!Generic.isEmail(document.frm.email.value)) {
                Generic.showError(document.frm.email, 'Λάθος email');
                return;
            } else {
                Generic.hideError(document.frm.email);
            }

            // server checks
            Generic.checkEmail(false, email);
            if ($('#check_email').html().length > 2) {
                Generic.showError(document.frm.email, 'Επιλέξτε άλλο email');
                return;
            } else {
                Generic.hideError(document.frm.email);
            }

            $('input:button').attr('disabled', 'true');
            Verify.validated = true;
            document.frm.submit();
        },
    };
}();
